<template>
  <transition
    enter-active-class="duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="duration-200 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <ul v-if="renderAuthLogin" class="flex flex-col-reverse lg:flex-row">
      <li>
        <UButton
          color="neutral"
          variant="solid"
          size="md"
          :label="t('auth.header.cottageRegistrationText')"
          :to="routes().ownerRegistration()"
          external
          class="mt-6 lg:mt-0 lg:mr-4"
        />
      </li>
      <li>
        <UButton
          variant="solid"
          size="md"
          :label="t('auth.header.loginText')"
          :to="renderAuthLogin?.urlLoginButton"
          external
        />
      </li>
    </ul>
  </transition>
</template>

<script setup lang="ts">
import type { AuthLogin } from '~/modules/auth/entities/AuthLogin'

interface RenderAuthLogin_Props {
  renderAuthLogin: AuthLogin
}

defineProps<RenderAuthLogin_Props>()
</script>
